module.exports = __webpack_public_path__ + "img/PhoneActive.30831cbf.svg";